import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';

import nous_dos from '../../images/desktop-backgrounds/nous_dos.jpeg';
import piscine from '../../images/desktop-backgrounds/piscine.jpg';
import hoschi_desktop from '../../images/desktop-backgrounds/hoschi_desktop.jpeg';
import bisou from '../../images/mobile-backgrounds/bisou.jpg';
import dos from '../../images/mobile-backgrounds/dos.jpg';
import hoschi from '../../images/mobile-backgrounds/hoschi.jpeg';
import yeux from '../../images/mobile-backgrounds/yeux.jpg';

const desktopImages = [nous_dos, piscine, hoschi_desktop];
const mobileImages = [bisou, dos, hoschi, yeux];

const BackgroundCarousel: React.FC = () => {
   const [index, setIndex] = useState(0);
   const [isMobile, setIsMobile] = useState(false);
   const [hasStartedTransition, setHasStartedTransition] = useState(false);

   useEffect(() => {
      const timeout = setTimeout(() => setHasStartedTransition(true), 5000);
      return () => clearTimeout(timeout);
   }, []);

   useEffect(() => {
      const handleResize = () => {
         setIsMobile(window.innerWidth < 768);
      };
      handleResize();
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
   }, []);

   useEffect(() => {
      if (!hasStartedTransition) return;

      const interval = setInterval(() => {
         setIndex((prev) => (prev + 1) % (isMobile ? mobileImages.length : desktopImages.length));
      }, 5000);

      return () => clearInterval(interval);
   }, [hasStartedTransition, isMobile]);

   return (
      <Box
         sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            overflow: 'hidden',
            zIndex: 0,
         }}
      >
         {[index, (index + 1) % (isMobile ? mobileImages.length : desktopImages.length)].map(
            (i, idx) => {
               const img = isMobile ? mobileImages[i] : desktopImages[i];
               const isCurrent = idx === 0;

               return (
                  <Box
                     key={i + '-' + idx}
                     sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backgroundImage: `url(${img})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        transform: `translateX(${isCurrent ? 0 : '100%'})`,
                        animation: hasStartedTransition
                           ? `${isCurrent ? 'slideOut' : 'slideIn'} 1.5s forwards`
                           : 'none',
                     }}
                  />
               );
            },
         )}
      </Box>
   );
};

export default BackgroundCarousel;
